import { apiSlice } from '../../../api/apiSlice';
import { SCORECARD_APPROVAL_ACTIVITY, SCORECARD_APPROVAL_ACTIVITY_EMPLOYEE } from '../../../constants';

export const ScorecardApprovalActivitySlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardApprovalActivity: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardId } = arg;
                return {
                    url: SCORECARD_APPROVAL_ACTIVITY,
                    params: { year, month, scorecardId },
                };
            },
        }),
        getScorecardApprovalActivityEmployee: builder.query({
            query: (arg: any) => {
                const { year, month,scorecardVersionId } = arg;
                return {
                    url: SCORECARD_APPROVAL_ACTIVITY_EMPLOYEE,
                    params: {  year, month, scorecardVersionId},
                };
            },
        }),
    }),
});

export const { useGetScorecardApprovalActivityQuery,
             useGetScorecardApprovalActivityEmployeeQuery } = ScorecardApprovalActivitySlice;
